'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterRedux = require('react-router-redux');

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _auth = require('../../redux/modules/auth');

var _Error = require('../../helpers/Error');

var _PopupType = require('../../helpers/PopupType');

var _popup = require('../../redux/modules/popup');

var _log = require('../../redux/modules/log');

var _ClientError = require('../../helpers/ClientError');

var _Logs = require('../../helpers/Logs');

var _Logs2 = _interopRequireDefault(_Logs);

var _Router = require('../../helpers/Router');

var _Product = require('../../helpers/Product');

var _DefaultString = require('../../helpers/DefaultString');

var _apple = require('../../../res/images/icon/apple.svg');

var _apple2 = _interopRequireDefault(_apple);

var _AppleLoginButton = require('./AppleLoginButton.scss');

var _AppleLoginButton2 = _interopRequireDefault(_AppleLoginButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppleLoginButton = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    appInfo: state.appInfo,
    auth: state.auth,
    initLang: state.auth.initLang,
    lang: state.auth.lang,
    log: state.log
  };
}, {
  changePopupType: _popup.changePopupType,
  appleLogin: _auth.appleLogin,
  appleUpgrade: _auth.appleUpgrade,
  logConnectionMethod: _log.logConnectionMethod,
  pushState: _reactRouterRedux.push
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(AppleLoginButton, _Component);

  function AppleLoginButton() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AppleLoginButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AppleLoginButton.__proto__ || (0, _getPrototypeOf2.default)(AppleLoginButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isSdkLoaded: false
    }, _this.onAppleLoginClick = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var user, applePasswordUri;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!_this.state.isSdkLoaded) {
                _context.next = 16;
                break;
              }

              _this.props.logConnectionMethod(_Logs.LogName.ConnectWithApple);
              (0, _Logs2.default)(_this.props.log.src, _Logs.LogName.ConnectWithApple, _this.props.log, _this.props.auth, _this.props.appInfo);

              _context.prev = 3;
              _context.next = 6;
              return AppleID.auth.signIn();

            case 6:
              user = _context.sent;
              applePasswordUri = window.location.protocol + '//' + window.location.host + (0, _Router.getPathForEmailLink)(_Router.RouterConst.CreatePasswordAndLinkToProfile, _this.props.lang);

              if (_this.props.auth.sessionId) {
                _this.props.appleUpgrade(user.authorization.code, _this.props.lang, applePasswordUri, _this.props.auth.sessionId);
              } else {
                _this.props.appleLogin(user.authorization.code, _this.props.lang, applePasswordUri);
              }
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context['catch'](3);

              // Only handle the error if it is not because the user closed the popup
              if (_context.t0.error !== 'popup_closed_by_user') {
                (0, _ClientError.logClientErrorWithLoggingService)(_context.t0, new Error().stack, 'universal-loginError-Apple', _this.props.auth);
                _this.props.changePopupType(_PopupType.PopupId.AppleLoginError);
              }

            case 14:
              _context.next = 18;
              break;

            case 16:
              (0, _ClientError.logClientErrorWithLoggingService)(new Error("Apple auth is unavailable or hasn't been loaded"), new Error().stack, 'universal-loginError-Apple', _this.props.auth);
              _this.props.changePopupType(_PopupType.PopupId.AppleLoginUnavailable);

            case 18:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[3, 11]]);
    })), _this.getText = function () {
      return _DefaultString.translations.Apple;
    }, _this.getIcon = function () {
      return _apple2.default;
    }, _this.initAppleSdk = function () {
      var product = (0, _Product.getThemedProduct)(_this.props.auth.productName, _this.props.auth.clientId);
      AppleID.auth.init({
        clientId: _this.props.appInfo.apple[product].clientId,
        scope: 'email',
        redirectURI: _this.props.appInfo.apple[product].redirectURI,
        usePopup: true // or false defaults to false
      });
    }, _this.sdkLoaded = function () {
      if (!_this.state.isSdkLoaded) {
        _this.setState({
          isSdkLoaded: true
        });

        if (!_this.hasCustomClick()) {
          _this.initAppleSdk();
        }
      }
    }, _this.loadSdk = function () {
      return new _promise2.default(function (resolve) {
        // if the apple-api-client script is already in the <head>, dont add another one
        var script = document.getElementById('apple-api-client');
        // otherwise add a script tag that will load the apple sign in sdk
        if (!script) {
          script = document.createElement('script');
          script.id = 'apple-api-client';
          script.type = 'text/javascript';
          script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
          script.async = true;
          if (script.readyState) {
            // For IE onload
            script.onreadystatechange = function () {
              if (script.readyState === 'loaded' || script.readyState === 'complete') {
                script.onreadystatechange = null;
                resolve();
              }
            };
          } else {
            // Other browsers onload
            script.onload = function () {
              return resolve();
            };
          }
          script.defer = true;
          document.getElementsByTagName('head')[0].appendChild(script);
        } else {
          resolve();
        }
      });
    }, _this.isEnabled = function () {
      var appleConfig = _this.props.appInfo.apple && _this.props.appInfo.apple[_this.props.auth.productName];
      return !!appleConfig && appleConfig.enableLogin;
    }, _this.hasCustomClick = function () {
      return [_Product.PLATFORM_NAMES.Ipad, _Product.PLATFORM_NAMES.Iphone, _Product.PLATFORM_NAMES.Android, _Product.PLATFORM_NAMES.AndroidTablet].includes(_this.props.auth.platform);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AppleLoginButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      if (this.isEnabled()) {
        this.loadSdk().then(function () {
          return _this3.sdkLoaded();
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.auth.appleLoggingIn && !nextProps.auth.appleLoggingIn) {
        if (nextProps.auth.error) {
          var response = nextProps.auth.error.response;
          if (response && (response.body.code === _Error.ErrorConst.InvalidCaptcha || response.body.code === _Error.ErrorConst.InvalidValue)) {
            this.props.changePopupType(_PopupType.PopupId.AppleLoginError);
          } else {
            (0, _ClientError.logClientErrorWithLoggingService)(nextProps.auth.error, new Error().stack, 'universal-loginError', this.props.auth);
            this.props.pushState((0, _Router.getErrorRetryPath)());
          }
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.isEnabled()) {
        return null;
      }
      var text = this.getText();
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'button',
          { type: 'button', className: _AppleLoginButton2.default.appleButton, onClick: this.onAppleLoginClick },
          _react2.default.createElement(
            'div',
            { className: 'social-icon-container' },
            _react2.default.createElement('img', { src: this.getIcon(), alt: this.props.intl.formatMessage(text) })
          ),
          _react2.default.createElement(_reactIntl.FormattedMessage, text)
        )
      );
    }
  }]);
  return AppleLoginButton;
}(_react.Component), _class2.propTypes = {
  appInfo: _react.PropTypes.object,
  auth: _react.PropTypes.object,
  changePopupType: _react.PropTypes.func,
  appleLogin: _react.PropTypes.func.isRequired,
  appleUpgrade: _react.PropTypes.func.isRequired,
  intl: _reactIntl.intlShape.isRequired,
  initLang: _react.PropTypes.string,
  lang: _react.PropTypes.string,
  pushState: _react.PropTypes.func.isRequired
}, _temp2)) || _class);
exports.default = (0, _reactIntl.injectIntl)(AppleLoginButton);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AppleLoginButton/AppleLoginButton.js
// module id = 1941
// module chunks = 0